/** Сравнивает две даты и определяет, являются ли они одним днём или нет */
export const isTheSameDate = (day1: Date, day2: Date) => {
  return (
    day1.getFullYear() === day2.getFullYear() &&
    day1.getMonth() === day2.getMonth() &&
    day1.getDate() === day2.getDate()
  );
};
